
import { Dialog, Disclosure, Popover } from '@headlessui/react';
import {
    Bars3Icon,
    XMarkIcon,
  } from '@heroicons/react/24/outline'
// import { Button } from '@material-tailwind/react';
  import { ReactComponent as Logo} from "../../assets/images/Logo.svg";
import { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import Button from '../../components/button';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import Footer from './footer';

const products = [
    { name: 'Analytics', description: 'Get a better understanding of your traffic', href: '#', icon: '' },
    { name: 'Engagement', description: 'Speak directly to your customers', href: '#', icon: '' },
    { name: 'Security', description: 'Your customers’ data will be safe and secure', href: '#', icon: '' },
    { name: 'Integrations', description: 'Connect with third-party tools', href: '#', icon: '' },
    { name: 'Automations', description: 'Build strategic funnels that will convert', href: '#', icon: '' },
  ]
  const callsToAction = [
    { name: 'Watch demo', href: '#', icon: '' },
    { name: 'Contact sales', href: '#', icon: '' },
  ]

export const Header=()=> {
  const { t } = useTranslation(["home"]);
  const navigate = useNavigate();

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    return (
      <>
        <header className="bg-white fixed top-0 w-full z-50">
        <nav className="mx-auto flex items-center justify-between p-3 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1 lg:mr-5">
            <a href="javascript:void(0)" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <Link to={'/'}>
              <Logo className="max-h-[77px] sm:h-[40px] w-auto" />
              </Link>
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <Popover.Group className="hidden lg:flex items-center gap-x-12">
            <Link to={'/'} className=" text-base font-semibold  text-black-dark">
              Home
            </Link>

          
            <Link to={'/fraud-prevention'}   className="text-base font-normal  text-black-dark">
            Fraud Prevention
            </Link>
            {/* <Link to={'/financialDisclosure'}  className="text-base font-normal  text-black-dark">
            Financial disclosure
            </Link> */}
            <Link to={'/afffiliateDisclosure'}  className="text-base font-normal  text-black-dark">
            Affiliate disclosure
            </Link>
            <Link to="/?tab=contactUs" className="text-base font-normal  text-black-dark">
            Contact us
            </Link>
            <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <Button
                  className="block  w-auto bg-blue"
                  onClick={() => navigate("/signin")}
                  // loading={isLoading}
                  type="submit"
                >
                  {t("Signin")}
                </Button>
            {/* <a href="javascript:void(0)" className="text-sm font-semibold leading-6 text-gray-900">
          Log in <span aria-hidden="true">&rarr;</span>
        </a> */}
          </div>
          </Popover.Group>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-10" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-full sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="javascript:void(0)" className="-m-1.5 p-1.5">
                <span className="sr-only">Your Company</span>
                <Link to={'/'}>
                <Logo className="h-10 w-auto" />
                </Link>
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
             
                <Link to={'/'} onClick={() => setMobileMenuOpen(false)} className="-mx-3 block font-semibold rounded-lg px-3 py-2  text-xl md:text-base  text-black-dark  leading-7 ">
              Home
            </Link>

            <Link to={'/?tab=contactUs'} onClick={() => setMobileMenuOpen(false)}  className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base font-normal  text-black-dark  leading-7 ">
            Contact us
            </Link>
            <Link to={'/fraud-prevention'} onClick={() => setMobileMenuOpen(false)}  className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base font-normal  text-black-dark  leading-7 ">
            Fraud Prevention
            </Link>
            <Link to={'/financialDisclosure'}  onClick={() => setMobileMenuOpen(false)} className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base font-normal  text-black-dark  leading-7 ">
            Financial disclosure
            </Link>
            <Link to={'/afffiliateDisclosure'} onClick={() => setMobileMenuOpen(false)}  className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base font-normal  text-black-dark  leading-7 ">
            Affiliate disclosure
            </Link>
            
                
                </div>
                <div className="py-6">
                <Button
                  className="block  w-auto bg-blue"
                  // loading={isLoading}
                  onClick={() => {navigate("/signin"); setMobileMenuOpen(false)}  }
                  type="submit"
                >
                  {t("Signin")}
                </Button>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
      <Outlet />
      <Footer />
      </>
    )
}

export default Header;